import { useDispatch } from 'react-redux';
import { COLOR_CONFIG, DARK_THEME_CSS, FONT_CONFIG, LAYOUT_CONFIG } from '../../../constants';
import { setShowText } from '../../../redux-tool/slice/controlSlice';

const TabletFloatingToolbar = ({
  hasActiveText,
  activePanel,
  setActivePanel,
  handleColorChange,
  handleFontChange,
  handleDeleteText,
  focusInput,
  handleNewText,
  color,
  fontFamily,
  activeTextId,
  findTextByIdMemo,
  setText,
  setShouldMaintainFocus,
  setShowFloatingInput,
  deselectText,
}) => {
  const dispatch = useDispatch();

  return (
    <>
      <style>
        {`
          ${DARK_THEME_CSS}

          .tablet-floating-toolbar {
            position: relative;
          }

          .tablet-action-group {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 12px;
            padding: 12px;
            background: rgba(30, 30, 30, 0.6);
            border: 1px solid rgba(255, 255, 255, 0.08);
            border-radius: 12px;
          }

          .tablet-toolbar-icon {
            position: relative;
            overflow: hidden;
            border: none;
            border-radius: 8px;
            background: rgba(60, 60, 60, 0.8);
            transition: all 0.2s ease;
            width: 44px;
            height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            box-shadow: none;
          }

          .tablet-toolbar-icon:not(.tablet-add-btn)::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(135deg, transparent, rgba(64, 224, 255, 0.12), transparent);
            transform: translateY(-100%);
            transition: transform 0.6s ease;
          }

          .tablet-toolbar-icon:hover::before {
            transform: translateY(100%);
          }

          .tablet-toolbar-icon:hover {
            transform: translateX(2px);
            background: rgba(80, 80, 80, 0.9);
          }

          .tablet-toolbar-icon.tablet-selected {
            background: rgba(64, 224, 255, 0.2) !important;
            color: #40E0FF !important;
            border: 2px solid rgba(255, 255, 255, 0.8) !important;
            box-shadow: 0 0 20px rgba(255, 255, 255, 0.4) !important;
            transform: scale(1.05) !important;
          }

          .tablet-toolbar-icon:disabled {
            cursor: not-allowed;
            opacity: 0.5;
            filter: grayscale(20%);
          }

          .tablet-toolbar-label {
            color: rgba(255, 255, 255, 0.8);
            font-size: 12px;
            letter-spacing: 0.4px;
            font-weight: 600;
          }

          .tablet-toolbar-group {
            display: flex;
            flex-direction: column;
            gap: 12px;
            width: 100%;
          }

          .tablet-toolbar-row {
            display: grid;
            grid-template-columns: 44px auto;
            align-items: center;
            gap: 14px;
          }

          .tablet-toolbar-subpanel {
            position: relative;
            flex: 1;
          }

          .tablet-color-palette-expanded,
          .tablet-font-selection-expanded {
            position: absolute;
            top: 0;
            left: calc(100% + 12px);
            min-width: 220px;
            max-width: 260px;
            background: rgba(40, 40, 40, 0.95);
            backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px);
            border-radius: 8px;
            padding: 12px 16px;
            border: none;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
            z-index: 20;
          }

          .tablet-color-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 10px;
          }

          .tablet-color-circle {
            width: 28px;
            height: 28px;
            border-radius: 50%;
            border: 2px solid transparent;
            transition: transform 0.2s ease;
            cursor: pointer;
          }

          .tablet-color-circle:hover {
            transform: scale(1.1);
          }

          .tablet-color-circle.tablet-selected {
            border-color: #40E0FF;
            box-shadow: 0 0 15px rgba(64, 224, 255, 0.6);
            transform: scale(1.1);
          }

          .tablet-font-list {
            display: flex;
            flex-direction: column;
            gap: 10px;
            max-height: 240px;
            overflow-y: auto;
            padding-right: 4px;
          }

          .tablet-font-pill {
            padding: 6px 12px;
            border-radius: 6px;
            border: none;
            background: rgba(60, 60, 60, 0.6);
            color: #FFFFFF;
            font-size: 12px;
            font-weight: 500;
            transition: all 0.2s ease;
            cursor: pointer;
          }

          .tablet-font-pill:hover {
            transform: translateX(2px);
            background: rgba(80, 80, 80, 0.8);
          }

          .tablet-font-pill.tablet-selected {
            background: rgba(64, 224, 255, 0.2);
            color: #40E0FF;
            border: 1px solid rgba(64, 224, 255, 0.6);
            box-shadow: 0 0 12px rgba(64, 224, 255, 0.4);
            transform: scale(1.02);
          }

          .tablet-slider-expanded {
            width: 260px;
          }

          .tablet-add-btn {
            border-radius: 8px !important;
            background: rgba(64, 224, 255, 0.15) !important;
            border: none !important;
          }

          .tablet-add-btn:hover {
            transform: translateX(2px);
            background: rgba(64, 224, 255, 0.25) !important;
          }

          .tablet-right-panel {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 12px;
            padding: 20px 16px;
            background: transparent;
            border-radius: 0;
            box-shadow: none;
            min-width: 120px;
            max-width: 120px;
            height: 100%;
          }

          @media (max-width: ${LAYOUT_CONFIG.TABLET_BREAKPOINT || 1024}px) {
            .tablet-toolbar-wrapper {
              width: 220px;
            }

            .tablet-color-palette-expanded,
            .tablet-font-selection-expanded {
              left: calc(100% + 8px);
              min-width: 200px;
              max-width: 220px;
            }
          }
        `}
      </style>

      <div
        className="tablet-floating-toolbar"
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'stretch',
          height: '100%',
          position: 'relative',
          zIndex: 50,
          marginLeft: '16px',
        }}
      >
        {/* Left Toolbar - Icon Buttons */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
            padding: '20px 16px',
            background: 'transparent',
            borderRadius: '0',
            borderRight: 'none',
            boxShadow: 'none',
            minWidth: '80px',
            maxWidth: '80px',
            height: '100%',
          }}
        >
          <div className="tablet-action-group">
            {/* Color Picker Button */}
            <button
              className={`tablet-toolbar-icon ${activePanel === 'color' ? 'tablet-selected' : ''}`}
              onClick={() => {
                if (hasActiveText) {
                  setActivePanel(activePanel === 'color' ? null : 'color');
                }
              }}
              disabled={!hasActiveText}
              aria-label="Change color"
              style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                background:
                  activePanel === 'color' ? 'rgba(64, 224, 255, 0.2)' : 'rgba(60, 60, 60, 0.8)',
                border:
                  activePanel === 'color'
                    ? '2px solid rgba(64, 224, 255, 0.6)'
                    : '2px solid rgba(255, 255, 255, 0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: hasActiveText ? 'pointer' : 'not-allowed',
                transition: 'all 0.2s ease',
                opacity: hasActiveText ? 1 : 0.5,
              }}
            >
              <img
                src="/theme/img/action-icon/color.svg"
                alt="Color"
                style={{ width: '28px', height: '28px' }}
              />
            </button>

            {/* Font Button */}
            <button
              className={`tablet-toolbar-icon ${activePanel === 'font' ? 'tablet-selected' : ''}`}
              onClick={() => {
                if (hasActiveText) {
                  setActivePanel(activePanel === 'font' ? null : 'font');
                }
              }}
              disabled={!hasActiveText}
              aria-label="Change font"
              style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                background:
                  activePanel === 'font' ? 'rgba(64, 224, 255, 0.2)' : 'rgba(60, 60, 60, 0.8)',
                border:
                  activePanel === 'font'
                    ? '2px solid rgba(64, 224, 255, 0.6)'
                    : '2px solid rgba(255, 255, 255, 0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: hasActiveText ? 'pointer' : 'not-allowed',
                transition: 'all 0.2s ease',
                opacity: hasActiveText ? 1 : 0.5,
              }}
            >
              <img
                src="/theme/img/action-icon/font.svg"
                alt="Font"
                style={{ width: '24px', height: '20px' }}
              />
            </button>

            {/* Edit Button */}
            <button
              className="tablet-toolbar-icon"
              onClick={() => {
                if (hasActiveText && activeTextId) {
                  const currentText = findTextByIdMemo(activeTextId);
                  if (currentText) {
                    setText(currentText.Text || '');
                    setShowFloatingInput?.(true);
                    setTimeout(() => focusInput?.(), 100);
                  }
                }
              }}
              disabled={!hasActiveText}
              aria-label="Edit text"
              style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                background: 'rgba(60, 60, 60, 0.8)',
                border: '2px solid rgba(255, 255, 255, 0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: hasActiveText ? 'pointer' : 'not-allowed',
                transition: 'all 0.2s ease',
                opacity: hasActiveText ? 1 : 0.5,
              }}
            >
              <img
                src="/theme/img/action-icon/edit.svg"
                alt="Edit"
                style={{ width: '24px', height: '20px' }}
              />
            </button>

            {/* Delete Button */}
            <button
              className="tablet-toolbar-icon"
              onClick={() => {
                if (hasActiveText && activeTextId) {
                  handleDeleteText(activeTextId);
                  deselectText?.();
                  dispatch(setShowText(false));
                }
              }}
              disabled={!hasActiveText}
              aria-label="Delete text"
              style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                background: 'rgba(60, 60, 60, 0.8)',
                border: '2px solid rgba(255, 255, 255, 0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: hasActiveText ? 'pointer' : 'not-allowed',
                transition: 'all 0.2s ease',
                opacity: hasActiveText ? 1 : 0.5,
              }}
            >
              <img
                src="/theme/img/action-icon/delete.svg"
                alt="Delete"
                style={{ width: '24px', height: '20px' }}
              />
            </button>
          </div>

          {/* Add New Button */}
          <button
            className="tablet-toolbar-icon"
            onClick={handleNewText}
            aria-label="Add new text"
            style={{
              width: '56px',
              height: '56px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #40E0FF 0%, #00BFFF 100%)',
              border: '2px solid rgba(64, 224, 255, 0.6)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              boxShadow: '0 4px 12px rgba(64, 224, 255, 0.3)',
              marginTop: '8px',
            }}
          >
            <img
              src="/theme/img/action-icon/new.svg"
              alt="Add"
              style={{ width: '28px', height: '28px' }}
            />
          </button>
        </div>

        {/* Right Panel - Color Swatches */}
        {activePanel === 'color' && hasActiveText && (
          <div className="tablet-right-panel">
            {COLOR_CONFIG.map((colorOption) => (
              <button
                key={colorOption.value}
                className={`tablet-color-circle ${
                  color === colorOption.value ? 'tablet-selected' : ''
                }`}
                onClick={() => {
                  handleColorChange(colorOption.value);
                  setShouldMaintainFocus?.(true);
                }}
                aria-label={`Select ${colorOption.name} color`}
                style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  backgroundColor: colorOption.value,
                  border:
                    color === colorOption.value
                      ? '2px solid #40E0FF'
                      : '2px solid rgba(255, 255, 255, 0.3)',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  backgroundImage:
                    colorOption.value === '#FFFFFF' || colorOption.value === '#000000'
                      ? 'radial-gradient(circle at 30% 30%, rgba(255,255,255,0.25), transparent 55%)'
                      : 'none',
                }}
              />
            ))}
          </div>
        )}

        {/* Font Selection Panel */}
        {activePanel === 'font' && hasActiveText && (
          <div className="tablet-right-panel" style={{ overflowY: 'auto' }}>
            {FONT_CONFIG.map((fontOption) => (
              <button
                key={fontOption.name}
                className={`tablet-font-pill ${
                  fontFamily === fontOption.family ? 'tablet-selected' : ''
                }`}
                onClick={() => handleFontChange(fontOption.family)}
                style={{
                  padding: '6px 12px',
                  borderRadius: '8px',
                  border:
                    fontFamily === fontOption.family
                      ? '1px solid #40E0FF'
                      : '1px solid rgba(255, 255, 255, 0.2)',
                  background:
                    fontFamily === fontOption.family
                      ? 'rgba(64, 224, 255, 0.2)'
                      : 'rgba(60, 60, 60, 0.8)',
                  color: fontFamily === fontOption.family ? '#40E0FF' : '#FFFFFF',
                  fontSize: '12px',
                  fontWeight: '500',
                  transition: 'all 0.2s ease',
                  cursor: 'pointer',
                  fontFamily: fontOption.family,
                  width: '100%',
                }}
                aria-label={`Select ${fontOption.name} font`}
              >
                {fontOption.name}
              </button>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default TabletFloatingToolbar;
